export enum SponsoredListingsSectionType {
  CampaignsView = 'CampaignsView',
  TimelineView = 'TimelineView',
}
